// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"67a9cd0c","453":"01943269","549":"a8e1c760","781":"865658b5"}[chunkId] + ".chunk.js";
};